<template>
  <div class="new_vip">
    <div class="title_line" v-if="!isCheck">
      <el-page-header @back="goBack" content="交班"></el-page-header>
    </div>
    <div class="button_box" v-if="!isCheck">
      <el-button
        type="primary"
        style="margin: 20px 10px;"
        @click="submit()"
        v-if="ifPrint"
        v-print="'#print_table'"
      >
        确定交班
      </el-button>
      <el-button
        type="primary"
        style="margin: 20px 10px;"
        @click="submit()"
        v-else
      >
        确定交班
      </el-button>
      <el-checkbox v-model="ifPrint" label="打印" border></el-checkbox>
      <el-button
        style="margin: 20px 10px;"
        @click="gotoHome()"
        v-if="showBackButton"
      >
        返回首页
      </el-button>
      <el-button
        style="margin-left: 20px;"
        @click="gotoOld()"
        v-if="Duty_type.duty_type == 0"
      >
        切换到旧版交班
      </el-button>
    </div>
    <div class="content">
      <div class="print_table" id="print_table" ref="print">
        <div class="print_table_line">
          <div class="column1">本次交班</div>
          <div class="flex1">
            {{ nowDate }}
            <span v-if="room_name">({{ room_name }})</span>
          </div>
        </div>
        <div class="print_table_line">
          <div class="column1" style="line-height: 80px;">员工/统计</div>
          <!-- <div class="part_recharge">
            <div class="part_title">充值订单</div>
            <div class="part_line">
              <div class="part_item bd_none">充值金额</div>
              <div class="part_item">赠送金额</div>
            </div>
          </div>-->
          <div class="part_order">
            <div class="part_title">加油订单</div>
            <div class="part_line">
              <div class="part_item bd_none">应收</div>
              <div class="part_item">优惠</div>
              <div class="part_item">实收</div>
            </div>
          </div>
          <div class="part_stat">
            <div class="part_title">支付方式</div>
            <div class="part_line">
              <div class="part_item_payment bd_none">现金</div>
              <div class="part_item_payment" style="width: 144px;">
                线上支付
              </div>
              <div class="part_item_payment">储值</div>
              <div class="part_item_payment">POS</div>
              <div class="part_item_payment">手续费</div>
              <div class="part_item">总计</div>
            </div>
          </div>
        </div>
        <div class="print_table_line" v-for="item in empList" :key="item.id">
          <div class="column1">{{ item.name }}</div>
          <div class="part_order">
            <div class="part_line line_h50">
              <div class="part_item bd_none">
                {{ item.emp_order_money || 0 }}
              </div>
              <div class="part_item">
                {{ item.emp_discount_money || 0 }}
              </div>
              <div class="part_item">{{ item.emp_order_amount || 0 }}</div>
            </div>
          </div>
          <div class="part_stat">
            <div class="part_line line_h50">
              <div class="part_item_payment bd_none">
                {{ item.emp_order_cash || 0 }}
              </div>
              <div class="part_item_payment" style="width: 144px;">
                {{
                  (
                    Number(item.emp_order_unionpay) +
                    Number(item.emp_order_wxpay || 0)
                  ).toFixed(2)
                }}
              </div>
              <div class="part_item_payment">
                {{ item.emp_order_other || 0 }}
              </div>
              <div class="part_item_payment">
                {{ item.emp_order_pos || 0 }}
              </div>
              <div class="part_item_payment">
                {{ item.emp_order_fee || 0 }}
              </div>
              <div class="part_item">{{ item.emp_order_amount || 0 }}</div>
            </div>
          </div>
        </div>
        <div class="print_table_line">
          <div class="column1">总计</div>
          <div class="part_order">
            <div class="part_line line_h50">
              <div class="part_item bd_none">
                {{ detailData.count.order_money }}
              </div>
              <div class="part_item">{{ detailData.count.order_discount }}</div>
              <div class="part_item">{{ detailData.count.order_amount }}</div>
            </div>
          </div>
          <div class="part_stat">
            <div class="part_line line_h50">
              <div class="part_item_payment bd_none">
                {{ detailData.count.order_cash }}
              </div>
              <div class="part_item_payment" style="width: 144px;">
                {{
                  (
                    Number(detailData.count.order_unionpay) +
                    Number(detailData.count.order_wxpay)
                  ).toFixed(2)
                }}
              </div>
              <div class="part_item_payment">
                {{ detailData.count.order_other }}
              </div>
              <div class="part_item_payment">
                {{ detailData.count.order_pos }}
              </div>
              <div class="part_item_payment">
                {{ detailData.count.order_fee }}
              </div>
              <div class="part_item">{{ detailData.count.order_amount }}</div>
            </div>
          </div>
        </div>
        <div class="print_table_line" style="padding-left: 15px;">
          <div class="bd_none">
            加油交班对账：
            {{
              (
                Number(detailData.count.order_unionpay || 0) +
                Number(detailData.count.order_discount || 0) +
                Number(detailData.count.order_other || 0) +
                Number(detailData.count.order_pos || 0) +
                Number(detailData.count.order_wxpay || 0)
              ).toFixed(2)
            }}元
            <span class="color_g">
              计算方式：（储值支付+POS+优惠+线上支付）
              加上员工上手的现金即可与加油机销售额对齐
            </span>
          </div>
        </div>
        <!--        v-if="empList.length>0&&detailData.count.platform_card_order_num>0"-->
        <div
          v-if="
            empList.length > 0 && detailData.count.platform_card_order_num > 0
          "
        >
          <div class="print_table_line">
            <div class="column1" style="line-height: 80px;">员工/统计</div>
            <div class="part_order" style="width: 91%;">
              <div class="part_title">平台卡订单</div>
              <div class="part_line">
                <div class="part_item bd_none">单数</div>
                <div class="part_item">线上支付</div>
                <div class="part_item">应收</div>
                <div class="part_item">平台扣除</div>
                <div class="part_item">手续费</div>
                <div class="part_item">实收</div>
              </div>
            </div>
          </div>
          <div
            class="print_table_line"
            v-for="(item, i) in empList"
            :key="'pingtai_' + i"
          >
            <div class="column1">{{ item.name }}</div>
            <div class="part_order" style="width: 91%;">
              <div class="part_line line_h50">
                <div class="part_item bd_none">
                  {{ item.emp_platform_card_order_num || 0 }}
                </div>
                <div class="part_item">
                  {{
                    (
                      Number(
                        item.emp_platform_card_order_normal_allinpay || 0
                      ) +
                      Number(item.emp_platform_card_order_unionpay || 0) +
                      Number(item.emp_platform_card_order_wxpay || 0)
                    ).toFixed(2)
                  }}
                </div>
                <div class="part_item">
                  {{ item.emp_platform_card_order_money || 0 }}
                </div>
                <div class="part_item">
                  {{ item.emp_platform_card_order_platform_money || 0 }}
                </div>
                <div class="part_item">
                  {{ item.emp_platform_card_order_fee || 0 }}
                </div>
                <div class="part_item">
                  {{ item.emp_platform_card_order_amount || 0 }}
                </div>
              </div>
            </div>
          </div>
          <div class="print_table_line">
            <div class="column1">总计</div>
            <div class="part_order" style="width: 91%;">
              <div class="part_line line_h50">
                <div class="part_item bd_none">
                  {{ detailData.count.platform_card_order_num }}
                </div>
                <div class="part_item">
                  {{
                    (
                      Number(
                        detailData.count.platform_card_order_normal_allinpay ||
                          0
                      ) +
                      Number(
                        detailData.count.platform_card_order_unionpay || 0
                      ) +
                      Number(detailData.count.platform_card_order_wxpay || 0)
                    ).toFixed(2)
                  }}
                </div>
                <div class="part_item">
                  {{ detailData.count.platform_card_order_money }}
                </div>
                <div class="part_item">
                  {{ detailData.count.platform_card_order_platform_money }}
                </div>
                <div class="part_item">
                  {{ detailData.count.platform_card_order_fee }}
                </div>
                <div class="part_item">
                  {{ detailData.count.platform_card_order_amount }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="print_table_line"
            style="height: 30px; color: red; line-height: 30px;"
          >
            平台卡计算方式: 应收 - 平台扣除 - 手续费 = 实收
          </div>
        </div>
        <div v-if="normal && normal.normal_num > 0">
          <div class="print_table_line">
            <div class="column1" v-if="time != 0" style="line-height: 80px;">
              员工/统计
            </div>
            <div class="column1" v-else style="line-height: 80px;"></div>
            <div class="part_order">
              <div class="part_title">普通订单</div>
              <div class="part_line">
                <div class="part_item bd_none">单数</div>
                <div class="part_item">应收</div>
                <!-- <div class="part_item">优惠</div> -->
                <div class="part_item">实收</div>
              </div>
            </div>
            <div class="part_stat">
              <div class="part_title">支付方式</div>
              <div class="part_line">
                <div class="part_item_payment bd_none">现金</div>
                <div class="part_item_payment" style="width: 144px;">
                  线上支付
                </div>
                <div class="part_item_payment">其他</div>
                <div class="part_item_payment">POS</div>
                <div class="part_item_payment">手续费</div>
                <!-- <div class="part_item">总计</div> -->
              </div>
            </div>
          </div>
          <template v-if="empNormalList.length > 0">
            <div
              class="print_table_line"
              v-for="item in empNormalList"
              :key="item.id"
            >
              <div class="column1">{{ item.name }}</div>
              <div class="part_order">
                <div class="part_line line_h50">
                  <div class="part_item bd_none">
                    {{ item.emp_normal_num || 0 }}
                  </div>
                  <div class="part_item">
                    {{ item.emp_normal_money || 0 }}
                  </div>
                  <div class="part_item">{{ item.emp_normal_amount || 0 }}</div>
                </div>
              </div>
              <div class="part_stat">
                <div class="part_line line_h50">
                  <div class="part_item_payment bd_none">
                    {{ item.emp_normal_cash || 0 }}
                  </div>
                  <div class="part_item_payment" style="width: 144px;">
                    {{
                      (
                        Number(item.emp_normal_unionpay) +
                        Number(item.emp_normal_wxpay || 0)
                      ).toFixed(2)
                    }}
                  </div>
                  <div class="part_item_payment">
                    {{ item.emp_normal_other || 0 }}
                  </div>
                  <div class="part_item_payment">
                    {{ item.emp_normal_pos || 0 }}
                  </div>
                  <div class="part_item_payment">
                    {{ item.emp_normal_fee || 0 }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="print_table_line">
            <div class="column1">总计</div>
            <div class="part_order">
              <div class="part_line line_h50">
                <div class="part_item bd_none">{{ normal.normal_num }}</div>
                <div class="part_item">{{ normal.normal_money }}</div>
                <!-- <div class="part_item">{{detailData.count.normal.normal_num}}</div> -->
                <div class="part_item">{{ normal.normal_amount }}</div>
              </div>
            </div>
            <div class="part_stat">
              <div class="part_line line_h50">
                <div class="part_item_payment bd_none">
                  {{ normal.normal_cash }}
                </div>
                <div class="part_item_payment" style="width: 144px;">
                  {{
                    (
                      Number(normal.normal_unionpay) +
                      Number(normal.normal_wxpay)
                    ).toFixed(2)
                  }}
                </div>
                <div class="part_item_payment">{{ normal.normal_other }}</div>
                <div class="part_item_payment">{{ normal.normal_pos }}</div>
                <div class="part_item_payment">{{ normal.normal_fee }}</div>
                <!-- <div class="part_item">{{detailData.count.normal.normal_num}}</div> -->
              </div>
            </div>
          </div>
          <div class="print_table_line" style="padding-left: 15px;">
            <div class="bd_none">
              普通订单对账：
              {{
                (
                  Number(normal.normal_unionpay) +
                  Number(normal.normal_other) +
                  Number(normal.normal_pos) +
                  Number(normal.normal_wxpay)
                ).toFixed(2)
              }}元
              <span class="color_g">
                计算方式：（其他支付+POS+线上支付） 加上员工上手的现金即可
              </span>
            </div>
          </div>
        </div>
        <div v-if="creditshop_data.sum && creditshop_data.sum > 0">
          <div class="print_table_line">
            <div class="column1" style="line-height: 80px;"></div>
            <div class="part_order">
              <div class="part_title">便利店订单</div>
              <div class="part_line">
                <div class="part_item bd_none">单数</div>
                <div class="part_item">应收</div>
                <!-- <div class="part_item">优惠</div> -->
                <div class="part_item">实收</div>
              </div>
            </div>
            <div class="part_stat">
              <div class="part_title">支付方式</div>
              <div class="part_line">
                <div class="part_item_payment bd_none" style="width: 50%;">
                  现金
                </div>
                <div
                  class="part_item_payment"
                  style="width: 50%; text-align: center;"
                >
                  线上支付
                </div>
              </div>
            </div>
          </div>
          <div class="print_table_line">
            <div class="column1">总计</div>
            <div class="part_order">
              <div class="part_line line_h50">
                <div class="part_item bd_none">
                  {{ creditshop_data.sum || 0 }}
                </div>
                <div class="part_item">
                  {{ creditshop_data.receivable_money || 0 }}
                </div>
                <div class="part_item">
                  {{ creditshop_data.receipts_money || 0 }}
                </div>
              </div>
            </div>
            <div class="part_stat">
              <div class="part_line line_h50">
                <div class="part_item_payment bd_none" style="width: 50%;">
                  {{ creditshop_data.cash_money || 0 }}
                </div>
                <div
                  class="part_item_payment"
                  style="text-align: center; width: 50%;"
                >
                  {{ creditshop_data.online_money || 0 }}
                </div>
              </div>
            </div>
          </div>
          <div class="print_table_line" style="padding-left: 15px;">
            <div class="bd_none">
              便利店订单对账：
              {{ creditshop_data.receipts_money || 0 }}元
              <span class="color_g">计算方式：线上支付加系统现金收款即可</span>
            </div>
          </div>
        </div>
        <div
          class="print_table_line"
          style="padding-left: 15px; border-left: none; border-right: none;"
        >
          充值
        </div>
        <div class="print_table_line">
          <div class="head_line bd_none">本班充值单数</div>
          <div class="flex1">{{ detailData.count.recharge_num }}</div>
          <div class="head_line">本班充值总金额</div>
          <div class="flex1">{{ detailData.count.recharge_amount }}</div>
          <div class="head_line">本班赠送金额</div>
          <div class="flex1">{{ detailData.count.recharge_balance }}</div>
        </div>
        <div class="print_table_line">
          <div class="head_line bd_none">本班支付方式</div>
          <div class="flex1">
            <span class="flex_span">
              线上支付：{{
                (
                  Number(detailData.count.recharge_unionpay) +
                  Number(detailData.count.recharge_wxpay)
                ).toFixed(2)
              }}
            </span>
            <span class="flex_span">
              POS：{{ detailData.count.recharge_pos }}
            </span>
            <span class="flex_span">
              现金：{{ detailData.count.recharge_cash }}
            </span>
            <span class="flex_span">
              手续费：{{ detailData.count.recharge_fee }}
            </span>
            <span class="flex_span">
              实际入账：{{
                (
                  Number(detailData.count.recharge_amount) -
                  Number(detailData.count.recharge_fee)
                ).toFixed(2)
              }}
            </span>
          </div>
        </div>
        <div class="print_table_line" v-if="duty_charge_count == 1">
          <div class="head_line bd_none" style="line-height: 110px;">
            充值统计
          </div>
          <div class="flex1 half_lh">
            <div class="half_item">总充值：{{ settle.recharge || 0 }}元</div>
            <div class="half_item">
              总充值赠送：{{ settle.recharge_balance || 0 }}元
            </div>
            <!-- <div class="half_item">总账户剩余：{{settle.balance}}元</div> -->
            <div class="half_item">
              后台总增加：{{ settle.admin_inc || 0 }}元
            </div>
            <div class="half_item">
              后台总减少：{{ settle.admin_dec || 0 }}元
            </div>
            <div class="half_item">订单总消费：{{ settle.order || 0 }}元</div>
          </div>
        </div>
        <div class="print_table_line" v-if="duty_charge_count == 1">
          <div
            class="flex1_ex bd_none"
            style="width: 120px; line-height: 60px;"
          >
            总账户剩余
          </div>
          <div class="flex1 half_lh">
            <div class="half_item" style="font-size: 16px; width: auto;">
              {{ settle.balance || 0 }}元
            </div>
            <span class="color_g">
              计算方式: 总充值 + 总赠送 + 后台增加 - 总订单消费 - 后台减少
            </span>
          </div>
        </div>
        <!-- <div class="print_table_line">
          <div class="head_line bd_none">本班充值支出</div>
          <div class="flex1">{{detailData.count.order_other}}元 （余额、加油卡、亲属卡、车队卡）</div>
        </div>-->
        <!-- <div class="print_table_line" style="line-height:40px;padding-left:10px;color:#ff1131;">
          交班队长计算方式：当前班次实际收入，包括充值和油品订单的银联与现金收入。(余额，加油卡，亲情卡，车队卡支付不计入)
        </div>-->
        <div class="print_table_line" style="padding-left: 15px;">
          <div class="bd_none">
            本班总收入
            {{
              (
                Number(detailData.count.unionpay || 0) +
                Number(detailData.count.wxpay || 0) +
                Number(detailData.count.pos || 0) +
                Number(creditshop_data.online_money || 0)
              ).toFixed(2)
            }}
            元
            <span>
              线上支付、POS支付的 (加油,普通订单,便利店)
              金额和充值金额（不包括现金）
            </span>
          </div>
        </div>
        <div class="print_table_line" style="padding-left: 15px;">
          手续费总金额：{{
            (
              Number(detailData.count.order_fee || 0) +
              Number(normal.normal_fee || 0) +
              Number(creditshop_data.fee || 0) +
              Number(detailData.count.recharge_fee || 0) +
              Number(detailData.count.platform_card_order_fee || 0) +
              Frees
            ).toFixed(2)
          }}元
          <span style="color: red;">
            (包括交易手续费+提现手续费【{{ Frees }}元】)
          </span>
        </div>
        <div v-if="duty_bank_arrival">
          <div v-if="Duty_type.duty_settlement == 1">
            <div
              v-if="
                (settelment.is_tl == 0 || !settelment.is_tl) &&
                  (settelment.is_lakala == 0 || !settelment.is_lakala) &&
                  (settelment.is_leshua == 0 || !settelment.is_leshua) &&
                  (settelment.is_fuiou == 0 || !settelment.is_fuiou)
              "
            >
              <div class="print_table_line1" style="padding-left: 15px;">
                <div>银行卡入账：{{ settelment.settle_amount || 0 }}元</div>
                <div>
                  结算时间：{{ settelment.settle_time_s }} ~
                  {{ settelment.settle_time_e }}
                  <span style="color: #d91104; font-size: 1rem;">
                    此时间仅供参考，具体时间以银行卡到账时间为准
                  </span>
                </div>
              </div>
              <div class="print_table_line1" style="padding-left: 15px;">
                <div>未到账：{{ settelment.wait_amount || 0 }}元</div>
                <div>
                  时间：{{ settelment.wait_time_s }} ~
                  {{ settelment.wait_time_e }}
                  <span style="color: #d91104; font-size: 1rem;">
                    此时间仅供参考，具体时间以银行卡到账时间为准
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="settelment.is_fuiou == 1">
            <div class="print_table_line1" style="padding-left: 15px;">
              富友入账：{{
                settelment.fuiou_settle_amount <= 0
                  ? "0.00"
                  : settelment.fuiou_settle_amount.toFixed(2)
              }}元
              <span style="color: red;">
                计算公式:
                (加油订单线上支付金额+充值订单线上支付金额)减去(交易手续费+{{
                  fuiou_free
                }}元提现手续费)
              </span>
              <div v-if="income_name">
                <span v-for="(item, i) in settelment.fuiou_collection" :key="i">
                  <span>
                    <span style="display: inline-block;">
                      {{ item.acnt_nm }}：
                    </span>
                    <span style="display: inline-block; margin-right: 10px;">
                      {{
                        Number(item.amount).toFixed(2) || "0.00"
                      }}元，提现手续费：{{ Number(item.fee).toFixed(2) }}
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div v-if="settelment.is_tl == 1">
            <!-- <div class="print_table_line" style="padding-left: 15px;">
              手续费总金额：{{
                (
                  Number(detailData.count.order_fee || 0) +
                  Number(normal.normal_fee || 0) +
                  Number(creditshop_data.fee || 0) +
                  Number(detailData.count.recharge_fee || 0) +
                  Number(detailData.count.platform_card_order_fee || 0) +
                  tl_free
                ).toFixed(2)
              }}元
              <span style="color: red;">
                (包括交易手续费+提现手续费【每个账户都有1元提现手续费】)
              </span>
            </div> -->
            <div class="print_table_line1" style="padding-left: 15px;">
              扫码银行卡入账：{{
                settelment.tl_settle_amount <= 0
                  ? "0.00"
                  : settelment.tl_settle_amount.toFixed(2)
              }}元
              <span style="color: red;">
                计算公式:
                (加油订单线上支付金额+充值订单线上支付金额)减去(交易手续费+1元提现手续费)
              </span>
              <div v-if="income_name">
                <span v-for="(item, i) in settelment.tl_collection" :key="i">
                  <span v-if="item.member_info">
                    <span style="display: inline-block;">
                      {{
                        item.member_info.memberType == "3"
                          ? item.member_info.name
                          : item.member_info.companyName
                      }}：
                    </span>
                    <span style="display: inline-block; margin-right: 10px;">
                      {{ Number(item.amount).toFixed(2) || "0.00" }}元
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div v-if="settelment.is_lakala == 1">
            <!-- <div class="print_table_line" style="padding-left: 15px;">
              手续费总金额：{{
                (
                  Number(detailData.count.order_fee || 0) +
                  Number(normal.normal_fee || 0) +
                  Number(creditshop_data.fee || 0) +
                  Number(detailData.count.recharge_fee || 0) +
                  Number(detailData.count.platform_card_order_fee || 0)
                ).toFixed(2)
              }}元
              <span style="color: red;">
                (包括交易手续费)
              </span>
            </div> -->
            <div class="print_table_line1" style="padding-left: 15px;">
              扫码银行卡入账：{{
                settelment.lakala_settle_amount <= 0
                  ? "0.00"
                  : settelment.lakala_settle_amount.toFixed(2)
              }}元
              <span style="color: red;">
                计算公式:
                (加油订单线上支付金额+充值订单线上支付金额)减去(交易手续费)
              </span>
              <div v-if="income_name">
                <span
                  v-for="(item, i) in settelment.lakala_collection"
                  :key="i"
                >
                  <span>
                    <span style="display: inline-block;margin-right: 10px;">
                      <!-- {{
                      item.member_info.memberType == '3'
                        ? item.member_info.name
                        : item.member_info.companyName
                    }}： -->
                      商户号：{{ item.mer_cup_no }}
                    </span>
                    <span style="display: inline-block; margin-right: 10px;">
                      入账：{{ Number(item.amount).toFixed(2) || "0.00" }}元
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div v-if="settelment.is_leshua == 1">
            <!-- <div class="print_table_line" style="padding-left: 15px;">
              手续费总金额：{{
                (
                  Number(detailData.count.order_fee || 0) +
                  Number(normal.normal_fee || 0) +
                  Number(creditshop_data.fee || 0) +
                  Number(detailData.count.recharge_fee || 0) +
                  Number(detailData.count.platform_card_order_fee || 0)
                ).toFixed(2)
              }}元
              <span style="color: red;">
                (包括交易手续费)
              </span>
            </div> -->
            <div class="print_table_line1" style="padding-left: 15px;">
              扫码银行卡入账：{{
                settelment.leshua_settle_amount <= 0
                  ? "0.00"
                  : settelment.leshua_settle_amount.toFixed(2)
              }}元
              <span style="color: red;">
                计算公式:
                (加油订单线上支付金额+充值订单线上支付金额)减去(交易手续费)
              </span>
              <div v-if="income_name">
                <span
                  v-for="(item, i) in settelment.leshua_collection"
                  :key="i"
                >
                  <span>
                    <span style="display: inline-block;">
                      {{ item.acct_name }}：
                      <!-- 商户号：{{ item.mer_cup_no }} -->
                    </span>
                    <span style="display: inline-block; margin-right: 10px;">
                      {{ Number(item.amount).toFixed(2) || "0.00" }}元
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="
              settelment.is_tl == 1 ||
                settelment.is_lakala == 1 ||
                settelment.is_leshua == 1 ||
                settelment.is_fuiou == 1
            "
          >
            <div class="print_table_line1" style="padding-left: 15px;">
              <div>
                刷卡银行卡到账：{{ settelment.pos_settle_amount || 0 }}元
              </div>
              <div>
                结算时间：{{ settelment.settle_time_s }} ~
                {{ settelment.settle_time_e }}
                <span style="color: red;">
                  此时间仅供参考，具体时间以银行卡到账时间为准
                </span>
              </div>
            </div>
            <div class="print_table_line" style="padding-left: 15px;">
              刷卡银行卡未到账：{{ settelment.pos_wait_amount || 0 }}元
              <span style="color: red;">
                此时间仅供参考，具体时间以银行卡到账时间为准
              </span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isCheck" style="text-align: center;">
        <el-button style="margin: 20px auto;" v-print="'#print_table'">
          打印
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { changeDutySubmit, classSetList } from "@/api/vip";
import { duty_config, privacy } from "@/api/set";
import { loading_options } from "@/utils/loading";
import { Loading } from "element-ui";

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  props: {
    detailMsg: {
      // 查看历史记录的数据
      type: Object,
      default: () => {},
    },
    DutyType: {
      type: Object,
      default: () => {},
    },
    isCheck: {
      // 是否是查看历史记录
      type: Boolean,
      default: false,
    },
  },
  watch: {
    DutyType: {
      handler: function(val) {
        console.log("chuandi", val);
        if (val) {
          this.Duty_type = val;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      duty_bank_arrival: true,
      income_name: 1,
      duty_charge_count: 1,
      tl_free: 0,
      fuiou_free: 0,
      Frees: 0,
      room_name: "",
      nowDate: "", //当前班次时间
      ifPrint: false, //是否打印
      showBackButton: false, //打印后显示返回按钮
      timeValue: [], // 时间
      detailData: {
        count: {},
      }, // 交班数据
      empList: [], // 员工数据
      time: 0,
      empNormalList: [], //普通订单员工数据
      totalNum: 0, // 交班对账金额
      class_id: "", // 班次id
      classList: [], //班次列表
      settelment: {
        settle: {},
        tl_collection: [],
      }, // 银行卡到账
      settle: {},
      normal: {},
      Duty_type: {},
      creditshop_data: {},
    };
  },
  mounted() {
    this.timeValue = this.$route.query.time || [];
    // this.init();
    if (!this.isCheck) {
      // this.checkVersion();
      this.init();
    }
    privacy({ app_id: this.app_id }).then((res) => {
      console.log(res);
      if (res.code == 200) {
        this.duty_charge_count = Boolean(res.data.duty_charge_count);
        this.income_name = Boolean(res.data.income_name);
        this.duty_bank_arrival = Boolean(res.data.duty_bank_arrival);
      }
    });
  },
  methods: {
    init() {
      // showLoading()
      const loading = Loading.service(loading_options);
      this.$nextTick(() => {
        classSetList({ token: this.token, app_id: this.app_id }).then((res) => {
          if (res.code == 200) {
            this.class_id = res.data[0].id;
            this.classList = res.data[0].rule;
            this.classList.forEach((item) => {
              if (item.type == 1) {
                item.show_name =
                  item.name + "  " + item.start_time + "~次日" + item.end_time;
              } else {
                item.show_name =
                  item.name + "  " + item.start_time + "~" + item.end_time;
              }
            });
          }
        });
      });
      var data = {
        token: this.token,
        app_id: this.app_id,
        duty_type: 2,
        room_id: this.$route.query.roomid,
      };
      if (this.timeValue.length == 2) {
        console.log("自定义交班时间", this.timeValue);
        data.start_time = this.timeValue[0];
        data.end_time = this.timeValue[1];
      }
      changeDutySubmit(data).then((res) => {
        if (res.code == 200) {
          console.log("357777", res.data);
          this.detailData = Object.assign(res.data);
          this.settle = res.data.settelment.settle;
          this.normal = res.data.count.normal;
          this.room_name = res.data.room_name;
          this.nowDate =
            this.mydateFormat(Number(this.detailData.begintime)) +
            " ~ " +
            this.mydateFormat(Number(this.detailData.endtime));
          let emp = res.data.emp || [];
          emp.forEach((e) => {
            if (e.emp_order_amount != 0) {
              this.empList.push(e);
            }
            if (e.emp_normal_amount != 0) {
              this.empNormalList.push(e);
            }
          });
          this.settelment = res.data.settelment || {};
          this.settelment.tl_collection =
            res.data.settelment.tl_collection || [];

          this.tl_free = res.data.settelment.tl_settle_amount_fee;

          this.fuiou_free = res.data.settelment.fuiou_settle_amount_fee;

          this.Frees = Number(this.tl_free || 0) + Number(this.fuiou_free || 0);
          this.creditshop_data = res.data.creditshop_order_data || {};
          // this.totalNum = (Number(res.data.count.cash)+Number(res.data.count.unionpay)+Number(res.data.count.wxpay)).toFixed(2)
          // hideLoading()
          this.$nextTick(() => {
            loading.close();
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
          // hideLoading()
          this.$nextTick(() => {
            loading.close();
          });
        }
      });
      duty_config({ app_id: this.app_id }).then((res) => {
        this.Duty_type = res.data;
        if (res.data.duty_type == 1) {
          localStorage.setItem("changeDutyVersion", 1);
          var thisQuery = this.$route.query;
          this.$router.replace({ path: "changeDutyNew", query: thisQuery });
        }
      });
    },
    goBack() {
      // 顶部返回
      this.$router.go(-1);
    },
    submit() {
      // 提交交班
      var data = {
        token: this.token,
        app_id: this.app_id,
        hand_money: 0,
        down_money: 0,
        class_id: this.class_id,
        class_key: 0,
        duty_type: 2,
        room_id: this.$route.query.roomid,
      };
      if (this.timeValue.length == 2) {
        console.log("自定义交班时间", this.timeValue);
        data.start_time = this.timeValue[0];
        data.end_time = this.timeValue[1];
      }
      // return false;
      changeDutySubmit(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "交班成功",
          });
          this.couldSubmit = false;
          if (this.ifPrint) {
            this.showBackButton = true;
          } else {
            this.gotoHome();
            // this.$router.go(-2);
          }
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    gotoHome() {
      // 返回首页
      this.$router.go(-2);
    },
    gotoOld() {
      // 切换旧版交班
      localStorage.setItem("changeDutyVersion", 1);
      var thisQuery = this.$route.query;
      this.$router.replace({ path: "changeDutyNew", query: thisQuery });
    },
  },
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .title_line {
    height: 34px;
  }
  .button_box {
    background: #fff;
    padding-left: 154px;
  }
  .content {
    background: #fff;
    padding: 24px 20px 0 24px;
    padding-bottom: 20px;
  }
}
.print_table {
  width: 840px;
  border-bottom: 1px solid #333;
  // border-top: none;
  font-size: 14px;
  color: #333;
  .print_table_line {
    line-height: 50px;
    display: flex;
    flex-wrap: nowrap;
    //justify-content: space-between;
    border: 1px solid #333;
    border-bottom: none;
    text-align: center;
    word-wrap: break-word;
    div {
      padding: 0;
      border-left: 1px solid #333;
    }
    span {
      padding-left: 10px;
    }
    .bd_none {
      border: none !important;
    }
    .info_text {
      font-size: 12px;
      flex: 1;
      color: #ff1131;
    }
    .column1 {
      width: 78px;
      border-left: none;
    }
    .flex1 {
      flex: 1;
    }
    .half_lh {
      display: flex;
      flex-wrap: wrap;
      padding: 6px 0px 6px 10px;
      .half_item {
        // line-height: 28px;
        width: 235px;
        text-align: left;
        border: none;
      }
    }
    .head_line {
      width: 120px;
      border-left: 1px solid #333;
    }
    .color_g {
      color: #00cd66;
      margin-left: 0;
    }
    .flex_span {
      margin: 0 10px;
      font-size: 13px;
    }
    .flex_right {
      margin-right: 15px;
      text-align: right;
    }
    .part_recharge {
      width: 150px;
      padding: 0;
    }
    .part_order {
      width: 240px;
      padding: 0;
    }
    .part_stat {
      flex: 1;
      padding: 0;
    }
    .part_title {
      line-height: 34px;
      height: 34px;
      border-bottom: 1px solid #333;
      border-left: none;
    }
    .part_line {
      line-height: 46px;
      display: flex;
      border-left: none;
      .part_item {
        font-size: 12px;
        flex: 1;
      }
      .part_item_payment {
        width: 72px;
        font-size: 12px;
      }
      .bd_left {
        border-left: 1px solid #333;
      }
    }
    .line_h50 {
      line-height: 50px !important;
    }
  }
  .print_table_line1 {
    line-height: 30px;
    //justify-content: space-between;
    border: 1px solid #333;
    border-bottom: none;
    word-wrap: break-word;
    div {
      padding: 0;
    }
    .bd_none {
      border: none !important;
    }
    .info_text {
      font-size: 12px;
      flex: 1;
      color: #ff1131;
    }
    .column1 {
      width: 78px;
      border-left: none;
    }
    .flex1 {
      flex: 1;
    }
    .half_lh {
      display: flex;
      flex-wrap: wrap;
      padding: 6px 0px 6px 10px;
      .half_item {
        // line-height: 28px;
        width: 235px;
        text-align: left;
        border: none;
      }
    }
    .head_line {
      width: 120px;
      border-left: 1px solid #333;
    }
    .color_g {
      color: #00cd66;
      margin-left: 0;
    }
    .flex_span {
      margin: 0 10px;
      font-size: 13px;
    }
    .flex_right {
      margin-right: 15px;
      text-align: right;
    }
    .part_recharge {
      width: 150px;
      padding: 0;
    }
    .part_order {
      width: 240px;
      padding: 0;
    }
    .part_stat {
      flex: 1;
      padding: 0;
    }
    .part_title {
      line-height: 34px;
      height: 34px;
      border-bottom: 1px solid #333;
      border-left: none;
    }
    .part_line {
      line-height: 46px;
      display: flex;
      border-left: none;
      .part_item {
        font-size: 12px;
        flex: 1;
      }
      .part_item_payment {
        width: 72px;
        font-size: 12px;
      }
      .bd_left {
        border-left: 1px solid #333;
      }
    }
    .line_h50 {
      line-height: 50px !important;
    }
  }
}
</style>
